import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMatternetComponent } from './simple-icons-matternet.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMatternetComponent ],
    exports:      [ SimpleIconsMatternetComponent ],
    bootstrap:    []
})
export class SimpleIconsMatternetModule {}
